import { NavLink } from "react-router-dom";

import { BrandMark } from "./BrandMark";

function navClass({ isActive }: { readonly isActive: boolean }) {
  return isActive ? "nav-link is-active" : "nav-link";
}

export function Header() {
  return (
    <header className="site-header">
      <div className="header-inner">
        <NavLink className="brand" to="/" aria-label="Wendo">
          <BrandMark />
          <span>Wendo</span>
        </NavLink>
        <nav className="main-nav" aria-label="主导航">
          <NavLink className={navClass} to="/" end>
            首页
          </NavLink>
          <NavLink className={navClass} to="/pdf-to-word">
            PDF 转 Word
          </NavLink>
          <NavLink className={navClass} to="/guide">
            使用说明
          </NavLink>
        </nav>
      </div>
    </header>
  );
}
